import { z, ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';

export type ShiftReport = {
	id: string;
	cashier: EntityWithName;
	cashdesk: EntityWithName;
	account: EntityWithName;
	startTime: string;
	endTime: string | null;
	currency: string;
	openingBalance: number;
	closingBalance: number;
	deposits: number;
	withdrawals: number;
	income: number;
	rtp: number;
	numberOfBets: number;
};

export const shiftReportSchema: ZodType<ShiftReport> = z.object({
	id: z.string(),
	cashier: entityWithNameSchema,
	cashdesk: entityWithNameSchema,
	account: entityWithNameSchema,
	startTime: z.string(),
	endTime: z.string().nullable(),
	currency: z.string(),
	openingBalance: z.number(),
	closingBalance: z.number(),
	deposits: z.number(),
	withdrawals: z.number(),
	income: z.number(),
	rtp: z.number(),
	numberOfBets: z.number(),
});
